var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a-spin',{attrs:{"spinning":_vm.confirmLoading}},[_c('DevBpbjInfoList',{ref:"infoList",attrs:{"pageType":"select"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }